export default "__VITE_ASSET__CgQWoCHt__"